import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const ProductGallerySkeleton = () => {
  return (
    <div className="productsDetail-lft">
      <div className="productGallery">
        <Skeleton height={400} borderRadius={8} />
      </div>

      <div className="small-img">
        <img
          src={
            "https://cdn.wes.com.au/wesreact/newui/plugins/pro-gallery/images/online_icon_right@2x.png"
          }
          className="icon-left"
          alt=""
          id="prev-img"
        />

        <div className="small-container">
          <div id="small-img-roll" style={{ display: "flex", gap: "8px" }}>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton key={index} width={60} height={60} borderRadius={6} />
            ))}
          </div>
        </div>

        <img
          src={
            "https://cdn.wes.com.au/wesreact/newui/plugins/pro-gallery/images/online_icon_right@2x.png"
          }
          className="icon-right"
          alt=""
          id="next-img"
        />
      </div>
    </div>
  );
};
